
var id = "KpiCustomer";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"KpiCustomer\">\n<style type=\"text/css\">\n\t#KpiCustomer .st0{fill-rule:evenodd;clip-rule:evenodd;}\n</style>\n<title>Group 5</title>\n<g id=\"KpiCustomer_one-page\">\n\t<g id=\"KpiCustomer_品牌健康中心\" transform=\"translate(-402.000000, -946.000000)\">\n\t\t<g id=\"KpiCustomer_KPI-Trend---ALL\" transform=\"translate(304.000000, 848.000000)\">\n\t\t\t<g id=\"KpiCustomer_KPI-Trend\" transform=\"translate(40.000000, 40.000000)\">\n\t\t\t\t<g transform=\"translate(42.000000, 50.000000)\">\n\t\t\t\t\t<g id=\"KpiCustomer_Group-5\" transform=\"translate(16.000000, 8.000000)\">\n\t\t\t\t\t\t<path id=\"KpiCustomer_Fill-1\" class=\"st0\" d=\"M10.4,13.1l0.1-0.5c0-0.1,0-0.1-0.1-0.1H9.6c-0.1,0-0.1,0-0.1,0.1l0.1,0.5v0.3l-0.9,5.5\n\t\t\t\t\t\t\tc0,0.1,0,0.3,0.1,0.4l0.9,0.6c0.1,0.1,0.3,0.1,0.4,0l0.9-0.6c0.1-0.1,0.3-0.3,0.3-0.4l-0.9-5.5V13.1z\" />\n\t\t\t\t\t\t<path id=\"KpiCustomer_Fill-3\" class=\"st0\" d=\"M5,5.5C5,3.1,7.3,1,10,1s5,2.1,5,4.5S12.7,10,10,10S5,7.9,5,5.5 M13.1,10.8\n\t\t\t\t\t\t\tc1.9-1,3.3-2.8,3.3-5C16.4,2.6,13.6,0,10,0S3.6,2.6,3.6,5.8c0,2.2,1.3,4,3.3,5C2.9,12,0,15.4,0,19.4C0,19.7,0.3,20,0.7,20\n\t\t\t\t\t\t\ts0.7-0.3,0.7-0.6c0-4.3,3.9-7.7,8.6-7.7s8.6,3.5,8.6,7.7c0,0.4,0.3,0.6,0.7,0.6c0.4,0,0.7-0.3,0.7-0.6\n\t\t\t\t\t\t\tC20,15.4,17.1,12,13.1,10.8\" />\n\t\t\t\t\t</g>\n\t\t\t\t</g>\n\t\t\t</g>\n\t\t</g>\n\t</g>\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
